import styled from "styled-components";
import SquadMakerHeader from "./SquadMakerHeader";
import BatterSquadMaker from "./BatterSquadMaker";
import PitcherSquadMaker from "./PitcherSquadMaker";
import Modal from "./Modal";
import SearchModal from "./SearchModal";
import DetailModal from "./DetailModal";
import FaceOnUploadModal from "./FaceOnUploadModal";
import SetDeckSidebar from "./SetDeckSidebar";
import { useEffect, useState } from "react";
import CustomPlayerModal from "./CustomPlayerModal";
import { ImageCacheProvider } from "../contexts/ImageCacheContext";


const StyledSquadMaker = styled.div`
    display: flex;
    flex-direction: column;
    width: 90rem;
    height: 64rem;
`

const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
`

const BatterContainer = styled.div`
    height: 100%;
`

const PitcherContainer = styled.div`
    height: 100%;
`

export default function SquadMaker() {

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault(); 
            event.returnValue = '';
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    
    return (
        <ImageCacheProvider>
            <StyledSquadMaker>

                <SearchModal/>
                <DetailModal/>
                <FaceOnUploadModal/>
                <CustomPlayerModal/>

                <SquadMakerHeader onSetDeckClick={() => setIsSidebarOpen(true)}/>

                <Container>

                    <SetDeckSidebar isSidebarOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)}/>

                    <BatterContainer>
                        <BatterSquadMaker></BatterSquadMaker>
                    </BatterContainer>

                    <PitcherContainer>
                        <PitcherSquadMaker></PitcherSquadMaker>
                    </PitcherContainer>

                </Container>
            </StyledSquadMaker>
        </ImageCacheProvider>
    )
}